export enum TabGroupValues {
  MY_ASSESSMENTS_DESKTOP = "My Assessments",
  ALL_ASSESSMENTS_MOBILE = "All",
  PROCESSING_ASSESSMENTS_MOBILE = "Processing",
  ALL_ASSESSMENTS_DESKTOP = "All Assessments",
  SITE_ASSESSMENTS = "Site Assessments"
}
